import Home from './pages/index/home'
import logo from './logo.svg';
import './App.css';

function App() {
  return (
     <Home/>
  );
}

export default App;
